import type { FC } from 'react';

import { useRestoreScroll } from '@jane/shared/hooks';

export const withScrollRestoration = <TProps extends object>(
  Component: FC<TProps>
) => {
  const WrappedComponent = (props: TProps) => {
    useRestoreScroll();
    return <Component {...props} />;
  };
  WrappedComponent.displayName = `withScrollRestoration(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
};
